import { TEntity, TEntityName, TEntityUntagged } from './types'

const cache = new WeakMap<object, object>()
export const fromUntagged = <T extends TEntityName>(
  tag: T,
  entity: TEntityUntagged<T>,
): TEntity<T> => {
  const cached = cache.get(entity)
  if (cached !== undefined) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    throwIfDifferentTags((cached as any)._tag, tag)
    return cached as TEntity<T>
  }

  let toBeCached: TEntity<T>
  if ('_tag' in entity) {
    const sneakyTag = entity._tag
    throwIfDifferentTags(sneakyTag, tag)
    toBeCached = entity as unknown as TEntity<T>
  } else {
    toBeCached = {
      ...entity,
      _tag: tag,
    } as unknown as TEntity<T>
  }

  cache.set(entity, toBeCached)
  return toBeCached
}

const throwIfDifferentTags = (
  actual: unknown,
  expected: string,
): void | never => {
  if (typeof actual !== 'string' || actual === expected) return

  throw new Error(`Entity already tagged as "${actual}", not"${expected}.`)
}
